import u from "classnames";
import r, { useCallback as M, useMemo as l } from "react";
import { Price as s } from "../price/price.esm.js";
import { ProductImage as D } from "../product-image/product-image.esm.js";
import { PromoIdentifier as V } from "../promo-identifier/promo-identifier.esm.js";
import { Rating as j } from "../rating/rating.esm.js";
import { Save as q } from "../save/save.esm.js";
import { TypographyComponent as y } from "../typography/typography-component.esm.js";
import { ColourSwatch as B } from "./colour-swatch.esm.js";
import { imageSources as G } from "./config.esm.js";
import { SkeletonCard as H } from "./skeleton-card.esm.js";
import { ListViewProductCard as fe } from "./list-view/list-view-product-card.esm.js";
const J = "_productCard_gvf85_1", K = "_productCard__link_gvf85_7", O = "_productCard__brand_gvf85_24", Q = "_productCard__title_gvf85_36", U = "_productCard__price_gvf85_46", W = "_productCard__saveForLater_gvf85_50", X = "_productCard__imageSpacing_gvf85_71", _ = {
  productCard: J,
  productCard__link: K,
  productCard__brand: O,
  productCard__title: Q,
  productCard__price: U,
  productCard__saveForLater: W,
  productCard__imageSpacing: X
}, Y = (i) => typeof i == "string" && i.length > 1, Z = { xxs: "small", m: "medium", l: "large" }, p = { xxs: "small", m: "medium" };
function P({
  catalogueId: i = "",
  title: v = "",
  brand: C = "",
  productUrl: g = "#",
  isSkeleton: k = !1,
  variant: n = "complex",
  image: d = {
    url: void 0,
    altText: void 0,
    isAltReal: !1,
    disabledLazy: !1,
    fetchPriority: void 0
  },
  price: a = {
    current: 0,
    showCurrentPriceFrom: !1,
    previous: 0,
    showPreviousPriceFrom: !1,
    saving: 0,
    showSave: !0,
    isEuro: !1
  },
  sfl: t = {
    saveCallback: null,
    isSaved: !1
  },
  stars: c = {
    rating: 0,
    reviewText: ""
  },
  swatches: w = [],
  promotionIdentifier: m = {
    displayName: "",
    colour: "black"
  },
  dataTestId: z = null,
  className: L,
  slotProps: e,
  ...f
}) {
  var h, S, x, N, E;
  const F = Y(d == null ? void 0 : d.altText) ? d == null ? void 0 : d.altText : `Missing image for: ${v}`, T = M(
    (R, ee, $) => {
      var b;
      R.preventDefault(), (b = t == null ? void 0 : t.saveCallback) == null || b.call(t, $);
    },
    [t]
  ), I = l(
    () => n === "simple" ? "m1" : { xxs: "m1", m: "m1", l: "1" },
    [n]
  ), o = l(
    () => n === "simple" ? "m1" : { xxs: "m1", m: "m1", l: "1" },
    [n]
  ), A = l(
    () => n === "simple" ? "s" : { xxs: "xs", m: "xs", l: "s" },
    [n]
  );
  return k ? /* @__PURE__ */ r.createElement(H, { ...f }) : /* @__PURE__ */ r.createElement(
    "div",
    {
      className: u(_.productCard, L, "fuse-product-card"),
      "data-testid": z || "fuse-product-card-data-testid",
      "data-tagg-id": i || void 0,
      ...f
    },
    /* @__PURE__ */ r.createElement(
      "a",
      {
        href: g,
        className: u(_.productCard__link, "fuse-product-card__link"),
        "data-testid": "fuse-product-card__link"
      },
      /* @__PURE__ */ r.createElement(
        D,
        {
          alt: F,
          src: d == null ? void 0 : d.url,
          lazy: !(d != null && d.disabledLazy),
          isAltReal: d == null ? void 0 : d.isAltReal,
          sources: G,
          fetchPriority: d == null ? void 0 : d.fetchPriority,
          ...e == null ? void 0 : e.productImage
        }
      ),
      (m == null ? void 0 : m.displayName) && /* @__PURE__ */ r.createElement(
        V,
        {
          color: m.colour || void 0,
          dataTestId: "fuse-product-card__promo-identifier",
          size: I,
          ...e == null ? void 0 : e.promoIdentifier,
          className: u(
            (h = e == null ? void 0 : e.promoIdentifier) == null ? void 0 : h.className,
            "fuse-product-card__promo-identifier"
          )
        },
        m.displayName
      ),
      /* @__PURE__ */ r.createElement("div", { className: _.productCard__imageSpacing }),
      /* @__PURE__ */ r.createElement(B, { swatches: w }),
      /* @__PURE__ */ r.createElement("div", { className: "productInfo" }, /* @__PURE__ */ r.createElement("div", { className: "persuasive-message" }), /* @__PURE__ */ r.createElement(
        y,
        {
          tag: "span",
          type: "paragraph",
          "data-testid": "fuse-product-card__brand",
          size: o,
          ...e == null ? void 0 : e.brand,
          className: u(
            _.productCard__brand,
            (S = e == null ? void 0 : e.brand) == null ? void 0 : S.className,
            "fuse-product-card__brand"
          )
        },
        C
      ), /* @__PURE__ */ r.createElement(
        y,
        {
          type: "heading",
          tag: "h3",
          "data-testid": "fuse-product-card__title",
          size: o,
          ...e == null ? void 0 : e.title,
          className: u(
            _.productCard__title,
            (x = e == null ? void 0 : e.title) == null ? void 0 : x.className,
            "fuse-product-card__title"
          )
        },
        v
      ), /* @__PURE__ */ r.createElement(
        s,
        {
          price: (a == null ? void 0 : a.current) || 0,
          headingTag: "h4",
          isEuro: a == null ? void 0 : a.isEuro,
          prevPrice: a == null ? void 0 : a.previous,
          saving: a == null ? void 0 : a.saving,
          showCurrentFrom: a == null ? void 0 : a.showCurrentPriceFrom,
          showPreviousFrom: a == null ? void 0 : a.showPreviousPriceFrom,
          showSave: a == null ? void 0 : a.showSave,
          size: A,
          dataTestId: "fuse-product-card__price",
          ...e == null ? void 0 : e.price,
          className: u(
            _.productCard__price,
            (N = e == null ? void 0 : e.price) == null ? void 0 : N.className,
            "fuse-product-card__price"
          )
        }
      ), c != null && c.rating ? /* @__PURE__ */ r.createElement(
        j,
        {
          rating: c == null ? void 0 : c.rating,
          reviewLinkText: c == null ? void 0 : c.reviewText,
          dataTestId: "fuse-product-card__rating",
          size: Z,
          ...e == null ? void 0 : e.rating
        }
      ) : null)
    ),
    (t == null ? void 0 : t.saveCallback) && typeof (t == null ? void 0 : t.saveCallback) == "function" && /* @__PURE__ */ r.createElement(
      q,
      {
        dataTestId: "fuse-product-card__save-for-later",
        showLabel: !1,
        saveLabel: `Save for later ${C} ${v}`,
        savedLabel: `Saved ${C} ${v}`,
        isSaved: t.isSaved,
        onClick: T,
        iconSize: p,
        ...e == null ? void 0 : e.saveForLater,
        className: u(
          _.productCard__saveForLater,
          (E = e == null ? void 0 : e.saveForLater) == null ? void 0 : E.className,
          "fuse-product-card__save-for-later"
        )
      }
    )
  );
}
P.displayName = "ProductCard";
export {
  fe as ListViewProductCard,
  P as ProductCard
};
